import http from './httpService';
import customHttp from './httpCustom';
import cookies from 'js-cookie';

export const registerService = (data) => {
  return http.post('/api/auth/register/applicant', data);
};

export const loginService = (data) => {
  console.log('=-=-=-))))=====>', cookies.get('i18next'));
  return http.post('/api/auth/login', data);
};

export const applicationService = () => {
  return http.get('/api/users/applicant');
};

export const nidService = (data) => {
  return http.post('/api/check/nationalId/applied', data);
};

export const emailService = (data) => {
  return http.post('/api/check/email', data);
};

export const phoneService = (data) => {
  return http.post('/api/check/phone', data);
};

export const maritalStatusService = async (data) => {
  try {
    const response = await http.post('/api/auth/nida/martialStatus', data);
    // console.log('API response:', response);
    let status = response.data.data;
    if (status === "Maried") {
      status = "Married";
    }
    return status; // Return response.data directly
  } catch (error) {
    throw error.response || error; // Properly propagate the error
  }
};

export const findAccountService = (data) => {
  return http.post('/api/auth/reset', data);
};

export const resetPasswordService = (data) => {
  return http.patch('/api/auth/reset', data);
};

export const confirmService = (data) => {
  return http.post('/api/auth/confirm', data);
};

export const allUsersService = (data) => {
  return http.post('api/auth/users', data);
};

export const resendEmail = (id) => {
  return customHttp.post(`api/auth/users/${id}/resendConfirmation`);
};

export const createUserAccountService = (data) => {
  return customHttp.post('/api/auth/register', data);
};

export const getOrganizationService = (data) => {
  return customHttp.get('/api/organisations', data);
};

export const changeEmail = (data) => {
  return customHttp.post('/api/auth/changeEmail/', data);
};

export const refreshToken = () => {
  return customHttp.get('/api/auth/refreshToken/');
};

export const verifyEmailChange = (data) => {
  return customHttp.patch('/api/auth/changeEmail/', data);
};
